import React from 'react';
import { Link } from 'react-router-dom';
import '../root.css';
import SEO from '../components/SEO';

function NotFoundPage() {
    return (
        <>
            <SEO
                title="Page Not Found | Samuel Banczík"
                description="This page does not exist. Return to the portfolio of Samuel Banczík, fullstack developer and startup founder."
                url="https://banczik.com/404"
                robots="noindex, follow"
            />
            <main style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem',
                padding: '2rem',
                textAlign: 'center',
                backgroundColor: 'var(--bg1)',
                color: 'var(--white)',
            }}>
                <h1 className="special-font2" style={{ fontSize: 'clamp(3rem, 12vw, 7rem)', margin: 0, fontWeight: 500 }}>404</h1>
                <p style={{ color: 'var(--gray)', maxWidth: '32rem', lineHeight: 1.6 }}>
                    This page does not exist.
                </p>
                <Link to="/" style={{ color: 'var(--blue)' }}>Back to the homepage</Link>
            </main>
        </>
    );
}

export default NotFoundPage;
